import Icon from '@mui/icons-material/Domain'
import React from 'react'

import { AccountCreate } from './create'
import { AccountEdit } from './edit'
import { AccountList } from './list'
import { ComponentWithSubheader } from 'dash/shared'

export default class Account {
  static Edit = () => {
    return <ComponentWithSubheader path={['Admin', 'Accounts']} component={AccountEdit} />
  }
  static List = () => <ComponentWithSubheader path={['Admin']} label="Accounts" component={AccountList} />
  static Create = () => (
    <ComponentWithSubheader path={['Admin', 'Accounts']} label="Create Account" component={AccountCreate} />
  )
  static Icon = Icon
}
